import { ButtonDanger, ButtonSecondary } from '@ui/button';
import { ModalDialog } from '@ui/modal-dialog';
import { useStore } from '@lib/state-engine';
import {
  $cannotRemoveVisible,
  $modalVisible,
  $successModalVisible,
  $warehouse,
  closeSubmit,
  closeCannotRemove,
  closeSuccess,
  remove,
  submit,
  $errorModalVisible,
  closeError,
  $pending,
} from './model';
import { IWarehouse } from '@@/warehouses/ts';
import { UiTextField } from '@@/ui/components/ui-text-field';
import { Button } from '@consta/uikit/Button';
import styles from './styles.module.sass';
import { useEffect, useState } from 'react';
import { set } from 'lodash-es';
import { ContentEditableEvent } from 'react-contenteditable';
import { DiContainer } from '@@/di/di-container';
import { WarehousesService } from '@@/warehouses/services/warehouses.service';
import {
  fetchAllWarehousesFx,
  fetchWarehouseByIdFx,
  fillWarehouseBagSuccess,
  renameWarehouse,
} from '@entities/warehouse/store';
import { responseErrorInterceptorNotification } from '@@/common/utils/response-error-interceptor-notification.util';
import { showInformer } from '@ui/status-informer';
import { notification } from 'antd';
import { warehouseModel } from '@/entities/warehouse';

const warehousesService = DiContainer.get(WarehousesService);

export function RemoveWarehouse(props: IRemoveWarehouseProps) {
  const { id, warehouseType } = props;
  const wh = useStore($warehouse);
  const confirmationVisible = useStore($modalVisible);
  const cannotRemove = useStore($cannotRemoveVisible);
  const success = useStore($successModalVisible);
  const error = useStore($errorModalVisible);
  const pendingDelete = useStore($pending);

  let [changingName, setChangingName] = useState(false);

  let [name, setName] = useState(wh?.name || '');

  let renaming = false;

  const saveName = async () => {
    if (!wh) return;
    renaming = true;
    const editedName = await warehousesService.rename(String(name), Number(wh.id)).catch((err) => {
      console.log(err);
      let result: string[] = [];
      if ('errors' in err) {
        for (const key in err.errors) {
          if (err.errors.hasOwnProperty(key)) {
              // Объединяем массив ошибок в одно сообщение, если в массиве несколько строк
              result = result.concat(err.errors[key]);
          }
        }
        result.map(item => notification.warning({ message: item }));
        return;
      }
      if ('error' in err) {
        showInformer({
          // @ts-ignore
          title: 'Ошибка',
          content: err.error || 'Ошибка сервера при переименовании',
          status: 'alert',
          timeout: 6000,
        });
      }
    });
    if (editedName) {
      setName(editedName.name);
      fetchWarehouseByIdFx(Number(id));
      notification.success({
        message:`Склад успешно переименован`
      })
      //fillWarehouseBagSuccess();
    }
    renaming = false;

    // fetchRenameWarehouse({ name, id: wh.id });
    // renameWarehouse({ name, id: wh.id });
    fetchAllWarehousesFx({});
  };

  useEffect(() => {
    if (String(name).length >= 60)
      return notification.warning({
        message: 'Название склада можеть иметь не более 60 символов',
      });
  }, [name]);

  return (
    <>
      <div className={styles.sform}>
        <UiTextField
          label="Название склада"
          labelPosition="left"
          maxLength={60}
          form="roundClear"
          value={name as string}
          disabled={!changingName}
          onChange={(event) => setName(event.value || '')}
        ></UiTextField>
        <Button
          form="brickRound"
          label={changingName ? 'Сохранить' : 'Изменить'}
          onClick={changingName ? saveName : () => setChangingName(true)}
          loading={renaming}
        />
      </div>

      <ButtonDanger onClick={() => remove(id)}>Удалить склад</ButtonDanger>
      {confirmationVisible && (
        <ModalDialog
          title={`Вы точно хотите удалить склад "${wh?.name}"?`}
          onClose={() => !pendingDelete && closeSubmit()}
          actions={
            <>
              <ButtonDanger disabled={pendingDelete} onClick={() => submit()}>
                Удалить
              </ButtonDanger>
              <ButtonSecondary
                disabled={pendingDelete}
                label="Отмена"
                onClick={() => closeSubmit()}
              />
            </>
          }
        >
          Отменить действие будет нельзя!
        </ModalDialog>
      )}
      {cannotRemove && (
        <ModalDialog
          title={`Склад "${wh?.name}" не может быть удален`}
          onClose={() => closeCannotRemove()}
        >
          На складе имеются заполненные хранилища: {wh?.filledBags} шт
        </ModalDialog>
      )}
      {success && (
        <ModalDialog
          title={`Склад "${wh?.name}" удален`}
          onClose={() => closeSuccess()}
        >
          Склад успешно удален
        </ModalDialog>
      )}
      {error && (
        <ModalDialog
          title={`Склад "${wh?.name}" не был удален`}
          onClose={() => closeError()}
        >
          Произошла ошибка при удалении склада!
        </ModalDialog>
      )}
    </>
  );
}

export interface IRemoveWarehouseProps {
  id: IWarehouse['id'];
  warehouseType: number;
}
